import { useDispatch } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { useOnMount } from '../../../hooks';
import * as IssuesV2Store from '../../../redux/issuesV2';

const IssueComparisonContainer: VoidFunctionComponent = () => {
  const dispatch = useDispatch();

  useOnMount(
    () => dispatch(IssuesV2Store.actions.enterComparisonMode()),
    () => dispatch(IssuesV2Store.actions.exitComparisonMode()),
  );

  return (
    // <ComparisonHeader />
    <div>
      lol
    </div>
  );
};

export default IssueComparisonContainer;
